import { INDICES } from "../actionTypes";
import { _getIndiceFutureData, _getIndices, _getWorldIndicesData } from "../../controllers";
import { deepClone, getDecryptLocalStorage } from "../../utils/global_functions";
import { LOCAL_STORAGE_KEYS } from "../../utils/global_variables";
import { getFutureTabDataSuccess } from "./marketOverview";
import { updatePersistIndicesData, updatePersistWorldIndicesData } from "./reduxPersistActions";



//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  --Start
export const getIndices = () => async (dispatch, getState) => {
    const userId = getState().auth.userId;
    const objLoginSession = getState()?.auth?.objLoginSession;
    const indicesData = getState()?.login?.indicesData;
    if (userId?.length > 0) {
        if (indicesData === null) {
            const objResp = await _getIndices(userId, objLoginSession);
            if (objResp.status) {
                dispatch(getIndicesSuccess(objResp?.data));
                dispatch(updatePersistIndicesData(objResp?.data));
            } else {
                dispatch(getIndicesFailure(objResp?.data));
            }
        } else {
            dispatch(getIndicesSuccess(indicesData));
        }


    } else { // Ameersha N - This else code was written because auth doesnt contain user id for guest user
        //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
        if (objLoginSession?.userId?.length > 0) {
            const objResp = await _getIndices(objLoginSession?.userId, objLoginSession);
            if (objResp.status) {
                dispatch(getIndicesSuccess(objResp?.data));
            } else {
                dispatch(getIndicesFailure(objResp?.data));
            }
        } else {

        }
        //Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End
    }
};
//Ameersha N - 16-11-2023 :- BT-104813 -- Dashboard Indices  --End


export const getAndLoadLocalIndicesOnLoad = () => (dispatch) => {
    let temp = JSON.parse(getDecryptLocalStorage(LOCAL_STORAGE_KEYS.HEADER_INDICES));
    if (temp) {
        dispatch(updateHeaderIndices(temp));
    } else {
        dispatch(updateHeaderIndices(
            [
                {
                    "nMarketSegmentId": 1,
                    "nToken": 26000,
                    "sIndex": "NIFTY",
                    "sIndexDesc": "Nifty 50",
                    "nIsDefaultIndex": 16,
                    "cIsIndex": "Y",
                    "isFavourite": false,
                    "LTP": "0",
                    "netChange": "0",
                    "lastTradeTime": "0",
                    "netChangeIndicator": "0",
                    "exchangeName": "NSE"
                },
                {
                    "nMarketSegmentId": 3,
                    "nToken": 19000,
                    "sIndex": "SENSEX",
                    "sIndexDesc": "SENSEX",
                    "nIsDefaultIndex": 16,
                    "cIsIndex": "Y",
                    "isFavourite": false,
                    "LTP": "0",
                    "netChange": "0",
                    "lastTradeTime": "0",
                    "netChangeIndicator": "0",
                    "exchangeName": "BSE"
                },
                {
                    "nMarketSegmentId": 1,
                    "nToken": 26009,
                    "sIndex": "BANKNIFTY",
                    "sIndexDesc": "Nifty Bank",
                    "nIsDefaultIndex": 16,
                    "cIsIndex": "Y",
                    "isFavourite": false,
                    "LTP": "0",
                    "netChange": "0",
                    "lastTradeTime": "0",
                    "netChangeIndicator": "0",
                    "exchangeName": "NSE"
                }
            ]
        ));
    }

};

export const updateIndicesScrollPosition = (payload) => {
    return { type: INDICES?.SCROLL_POSITION, payload };
};

export const getIndicesSuccess = (payload) => {
    return { type: INDICES.GET_INDICES_SUCCESS, payload };
};

export const getIndicesFailure = (payload) => {
    return { type: INDICES.GET_INDICES_FAILURE, payload };
};


export const updateStoredIndices = (payload) => {
    return { type: INDICES?.UPDATE_LOCAL_INDICES, payload };
};




export const getWorldIndicesData = () => async (dispatch, getState) => {
    const worldIndicesData = getState()?.login?.worldIndicesData;
    if (worldIndicesData === null) {
        const objResp = await _getWorldIndicesData();

        if (objResp?.status) {
            dispatch(getWorldIndicesDataSuccess(objResp?.data));
            dispatch(updatePersistWorldIndicesData(objResp?.data));
        } else {
            dispatch(getWorldIndicesDataFailure(objResp?.data));
        }
    }else{
        dispatch(getWorldIndicesDataSuccess(worldIndicesData));
    }

};

export const getWorldIndicesDataSuccess = (payload) => {
    return { type: INDICES.GET_WORLD_INDICES_SUCCESS, payload };
};

export const getWorldIndicesDataFailure = (payload) => {
    return { type: INDICES.GET_WORLD_INDICES_FAILURE, payload };
};

export const setIsIndicesOverview = (payload) => {
    return { type: INDICES.SET_IS_INDICES_OVERVIEW, payload };
};

export const getIndiceFutureData = (payload) => async (dispatch, getState) => {
    const whatsHotData = deepClone(getState().dontMiss?.whatsHotData);
    const objResp = await _getIndiceFutureData(whatsHotData, payload);

    if (objResp?.status) {
        dispatch(getIndiceFutureDataSuccess(objResp?.data));
        // Updates redux so data can be used in Future tab for add leg in multileg
        dispatch(getFutureTabDataSuccess(objResp?.data));

    } else {
        dispatch(getIndiceFutureDataFailure(objResp?.data));
    }
};

export const getIndiceFutureDataSuccess = (payload) => {
    return { type: INDICES.GET_INDICES_FUTURE_DATA_SUCCESS, payload };
};

export const getIndiceFutureDataFailure = (payload) => {
    return { type: INDICES.GET_INDICES_FUTURE_DATA_FAILURE, payload };
};

export const resetIndiceOverView = () => {
    return { type: INDICES.RESET_INDICE_OVERVIEW };
};

export const setIndiceOverviewData = (payload) => {
    return { type: INDICES.SET_INDICE_OVERVIEW_DATA, payload };
};

//Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices - Start
export const updateFavoritesIndicesSuccess = (payload) => {
    return { type: INDICES.UPDATE_FAVORITE_INDICES_SUCCESS, payload };
};
//Prachi T - 27-11-2023 :- BT-104813 -- Dashboard Indices - End

// Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices Start
export const updateHeaderIndices = (payload) => {
    return { type: INDICES.UPDATE_HEADER_INDICES, payload };
};
// Parshva S - 12/12/2023 - BT-123521 : Breeze - Header Indices End